<template>
  <v-card>
  <v-layout wrap>
    <v-flex xs8 style="">
    <v-data-table
      :headers="headers"
      :items="sources"
      elevation="0"
      :items-per-page="10000"
      :loading="loading"
      hideDefaultFooter
      class="source"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Identificadores de acceso</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.ident="{ item }">
        <a @click="handleEdit(item)">{{ item.Name && item.Name.length > 0 ? item.Name : item.ID}}</a>
      </template>
      <template v-slot:item.URL="{ item }">
        {{ item.URL}}
      </template>
      <template v-slot:item.QR="{ item }">
        <template-qr 
          :item="item" 
          :enterpriseColor="enterpriseColor"
        />
      </template>
    </v-data-table>

    </v-flex>
    <v-flex xs4 style="padding: 10px;">
      <v-btn
        v-if="!editedItem"
        block
        dark
        :color="enterpriseColor"
        @click="handleAdd"
      >
        {{ $t('common.add', locale) }}
      </v-btn>

      <v-layout wrap v-else>
        <v-flex xs12>
          <v-text-field
            label="Nombre"
            outlined
            v-model="editedItem.Name"
            dense
            hide-details
          />
        </v-flex>
        <v-flex xs12 style="text-align: right;padding-top: 20px;">
        <v-spacer />
        <v-btn class="mr-4" @click="handleDelete" color="red" dark>{{ $t('common.delete', locale) }}</v-btn>
        <v-btn class="mr-4" @click="handleClose">{{ $t('common.cancel', locale) }}</v-btn>
        <v-btn dark :color="enterpriseColor" @click="handleSave">{{ $t('common.save', locale) }}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  </v-card>
</template>
<script>
import api from '@/services/api'
import TemplateQr from './TemplateQr'
export default {
  components: {
    TemplateQr,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    onChangeSourcesList: {
      type: Function,
      required: true,
    },
  },
  data: () =>({
    loading: false,
    editedItem: null,
    sources: [],
  }),
  computed: {
    enterpriseColor () {
      return this.$store.state.app.enterpriseColor
    },
    headers () {
      return [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'ident',
        },
        {
          text: 'URL',
          align: 'start',
          sortable: false,
          value: 'URL',
        },
        {
          text: 'QR',
          align: 'center',
          sortable: false,
          value: 'QR',
        },
      ]
    }
  },
  watch: {
    workspaceID () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      this.loading = true
      api.getAll(`enterprises/${this.workspaceID}/stats-sources`, true, 1, 100000, '')
        .then(response => {

          const a = response.map(item => {
           return {
              ID: item.ID,
              Name: item.Name
            }
          })
          a.unshift({ID: null, Name: 'TODOS'})

          this.onChangeSourcesList(a)
          this.sources = response.map(item => {
            item.ident = { id: item.ID, name: item.Name}
            return item
          })
          this.handleClose()
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
    },
    handleAdd () {
      this.editedItem = {
        ID: null,
        WorkspaceID: this.workspaceID,
        Name: '',
      }
    },
    handleEdit (v) {
      this.editedItem = JSON.parse(JSON.stringify(v))
    },
    handleSave () {
      if (this.editedItem.ID) {
        api.updateItem(`stats-sources`, this.editedItem.ID, this.editedItem)
          .then(response => {
            console.log('response', response)
            this.handleGetData()
          })
      } else {
        api.addItem(`stats-sources`, this.editedItem)
          .then(response => {
            console.log('response', response)
            this.handleGetData()
          })
      }
    },
    handleDelete () {
      api.deleteItem(`stats-sources`, this.editedItem.ID)
        .then(response => {
          console.log('response', response)
          this.handleGetData()
        })
    },
    handleClose () {
      this.editedItem = null
    },
  },
}
</script>
<style>
.source {
  margin-bottom: 10px;
}
.source td {
  vertical-align: middle;
}
</style>

